import styles from './CareersListings.scss';

import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Category } from 'src/api/greenhouse/JobBoards';

interface CareersListingsProps extends React.AllHTMLAttributes<HTMLElement> {
  categories: ReadonlyArray<Category>;
}

export const CareersListings: React.FunctionComponent<CareersListingsProps> = ({ categories, className, ...props }) => {
  const { t } = useTranslation();

  return (
    <section className={cx(className, styles.listingsWrapper)} {...props}>
      {!categories.length && <div className={`${styles.jobRow}`}>{t('no-jobs-currently')}</div>}
      {categories.filter(({ jobs }) => !!jobs.length).map(({ id, name, jobs }) => (
        <React.Fragment key={id}>
          <h4 className={styles.title}>{name}</h4>
          {jobs.map(({ id, title, url, location }) => (
            <div key={id} className={`${styles.jobRow} ${styles.jobData}`}>
              <div className={styles.jobTitle}>
                <a href={`/job-post?gh_jid=${id}`}>{title}</a>
              </div>
              <div>{location}</div>
            </div>
          ))}
        </React.Fragment>
      ))}
    </section>
  );
};
